import * as React from 'react';
import { FirstTimeWalkthroughSteps } from '@/types/walkthroughs';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import {
    getItemModelCatalogId,
    getItemModelCatalogOnly,
    getItemModelCatalogStatus,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { useAppSelector } from '@/redux/hooks';
import BidConsoleOpener from '@/components/BidConsoleOpener/BidConsoleOpener';
import Button from '@liveauctioneers/caterwaul-components/lib/Button/Button';
import noop from '@/utils/noop';
import styled from 'styled-components';

type Props = {
    itemId: number;
};

const ItemBiddingEnterButton = ({ itemId }: Props) => {
    const catalogId = useAppSelector((state) => getItemModelCatalogId(state, itemId));
    const catalogStatus = useAppSelector((state) => getItemModelCatalogStatus(state, itemId));
    const isCatalogOnly = useAppSelector((state) => getItemModelCatalogOnly(state, itemId));

    return catalogStatus === 'live' && !isCatalogOnly ? (
        <BidConsoleOpener catalogId={catalogId}>
            <StyledButton
                data-walkthrough-step={FirstTimeWalkthroughSteps.LiveItem}
                id="ItemBiddingEnter"
                onClick={noop}
                secondary
            >
                <FormattedMessage id="enter_live_auction" />
            </StyledButton>
        </BidConsoleOpener>
    ) : null;
};

export default React.memo<Props>(ItemBiddingEnterButton);

const StyledButton = styled(Button)`
    min-width: 100%;
`;
